import React from 'react';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import ProductCartItem from "../../components/ProductCartItem/ProductCartItem.js";
import { Link  } from "react-router-dom";
import { ReactSVG } from 'react-svg';

import './ShoppingCart.css'; 
import { Utils } from '../../Utils.js';

class ShoppingCart extends React.Component {

  dialogRef = React.createRef();
  
  emptyFormData = {
    coupon_code: '',
    loyalti_code: '',
    loyalti_use_gross: '',
    loyalti_coupon_id: '',
  };

  emptyFormErrors = {
    coupon_code: '',
    loyalti_code: '',
  };

  emptyFormSuccess = {
    coupon_code: '',
    loyalti_code: '',
  };

  constructor(props) {
    super(props);
    
    this.state = {
      loading: false,
      shopping_cart: {},
      coupon_form_open: false,
      loyalti_form_open: false,
      selected_ugyfelkartya: null,
      show: false,
      hiding: false,
      formData: { ...this.emptyFormData },
      formErrors: { ...this.emptyFormErrors },
      formSuccess: { ...this.emptyFormSuccess },
    };
  }

  componentDidMount()
  {
    if(window.AppRef.current?.state?.shopping_cart)
    {
      this.set_shopping_cart(window.AppRef.current.state.shopping_cart);
    }
  }
  
  set_shopping_cart(shopping_cart)
  {
    this.setState({shopping_cart:shopping_cart,loading:false});

    const errors = {...this.state.formErrors};
    const success = {...this.state.formSuccess};
    const form_data = {...this.state.formData};

    if(shopping_cart?.discounts?.coupon_system?.coupon_errors){
      errors['coupon_code'] = shopping_cart.discounts.coupon_system.coupon_errors;
      this.setState({formErrors:errors});
    }else{
      errors['coupon_code'] = '';
      this.setState({formErrors:errors});
    }

    if(shopping_cart?.discounts?.coupon_system?.is_valid_filtered){
      success['coupon_code'] = shopping_cart.discounts.coupon_system.coupon_label;
      this.setState({formSuccess:success});
    }else{
      success['coupon_code'] = '';
      this.setState({formSuccess:success});
    }

    if(shopping_cart?.discounts?.ugyfelkartya?.ugyfelkartya_errors){
      errors['loyalti_code'] = shopping_cart.discounts.ugyfelkartya.ugyfelkartya_errors;
      this.setState({formErrors:errors});
    }else{
      errors['loyalti_code'] = '';
      this.setState({formErrors:errors});
    }

    if(shopping_cart?.discounts?.ugyfelkartya?.ugyfelkartya_number){
      form_data['loyalti_code'] = shopping_cart.discounts.ugyfelkartya.ugyfelkartya_number;
      this.setState({formData:form_data});
    }
    else if(form_data['loyalti_code'] === '' && window.AppRef.current.state.user_data?.customer_card_number){
      form_data['loyalti_code'] = window.AppRef.current.state.user_data?.customer_card_number;
      this.setState({formData:form_data});
    }
  }

  show() {
    this.setState({show: true}, () => {
      window.AppRef.current.handle_keyboard_events();
    });
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
        //window.AppFooterMenuRef.current.set_item_inactive_by_name('shopping_cart');
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    } 
    else {
      this.show();
    }
  }

  show_coupon_form() {
    this.setState({coupon_form_open: true});
  }

  hide_coupon_form() {
    this.setState({coupon_form_open: false});
  }

  toggle_coupon_form_open() {
    if (this.state.coupon_form_open)
    {
      this.hide_coupon_form();
    }
    else {
      this.show_coupon_form();
    }
  }

  handle_coupon_submit() {
    let params = {};
 
    params['select_coupon'] = this.state.formData?.coupon_code;
    //params['loyalti_code'] = this.state.formData?.loyalti_code;
    //params['loyalti_gross'] = this.state.formData?.loyalti_use_gross;
    //params['loyalti_coupon_id'] = this.state.formData?.loyalti_coupon_id;

    params['select_ugyfelkartya'] = this.state.formData?.loyalti_code;
    params['select_ugyfelkartya_gross'] = this.state.formData?.loyalti_use_gross;

    Utils.shopping_cart_set_coupon(params);

  }

  show_loyalti_form() {
    this.setState({loyalti_form_open: true});
  }

  hide_loyalti_form() {
    this.setState({loyalti_form_open: false});
  }

  toggle_loyalti_form_open() {
    if (this.state.loyalti_form_open)
    {
      this.hide_loyalti_form();
    }
    else {
      this.show_loyalti_form();
    }
  } 

  handle_loyalti_submit() {

    const loyalti_data = this.create_loaylty_data_from_state();
    const post_data = Utils.shopping_cart_set_loyalti_codes({},loyalti_data);

    Utils.get_update_shopping_cart(post_data);
  }

  create_loaylty_data_from_state(){

    const loyalti_data = {
      'coupon_code' : this.state.formData?.coupon_code,
      'loyalti_code' : this.state.formData?.loyalti_code,
      'loyalti_gross': this.state.formData?.loyalti_use_gross,
      'loyalti_coupon_id': this.state.formData?.loyalti_coupon_id
    };
    
    return loyalti_data; 
  }

  handle_quantity_click(e) {
    e.preventDefault();
  }  

  handle_submit(e) {
    e.preventDefault();

    const loyalti_data = this.create_loaylty_data_from_state();
    const coupon_code = this.state.formData?.coupon_code;
    const post_data = Utils.shopping_cart_set_loyalti_codes({},loyalti_data);
    
    if(coupon_code){
      post_data['select_coupon'] = coupon_code;
    }

    post_data['select_ugyfelkartya'] = this.state.formData?.loyalti_code;
    post_data['select_ugyfelkartya_gross'] = this.state.formData?.loyalti_use_gross;
  
    window.modals.CheckoutSummaryRef.current.init_checkout(post_data);
    window.modals.CheckoutSummaryRef.current.toggle();

  }

  handle_change(event, formDataKey, force_value = null,callback) {
    const formData = this.state.formData;

    formData[formDataKey] = force_value !== null ? force_value : event.target.value;

    this.setState({formData},callback);

  }

  /**
   * A ProductCartItem elem hívja meg, a termék mennyiségének a módosításakor.
   * 
   * @param {*} product
   */
  on_change_product(product,event) {
    
    const order_id = this.state.shopping_cart.order_id;
    const cart_copy = {...this.state.shopping_cart}
    const coupon_code = this.state.formData?.coupon_code;

    if(cart_copy.products)
    {
      Object.keys(cart_copy.products).forEach((val,index)=>{
        if(parseInt(cart_copy['products'][val].id) === parseInt(product.id))
        {
          cart_copy['products'][val].pc = parseInt(product.pc);
        }
      })
    }

    this.setState({'shopping_cart':cart_copy,'loading':true});

    const loyalti_data = this.create_loaylty_data_from_state();
    
    if(product.pc===0){
      Utils.shopping_cart_delete(product,order_id,coupon_code,loyalti_data);
    }else if(product.pc>0){
      Utils.shopping_cart_modify(product,order_id,coupon_code,loyalti_data);
    }    
  }

  on_change_royalti_card(event, formDataKey, force_value = null,callback) {
    const formData = this.state.formData;

    formData['loyalti_code'] = force_value !== null ? force_value : event.target.value;

    this.setState({formData},callback);

    Utils.get_server_data('', { ajax_event:'get_shoppingcart', APICACHE:'false', select_ugyfelkartya: formData['loyalti_code'] })
      .then((res)=>{
          window.AppRef.current.setState({user_data:res.user_data ? res.user_data : {}}, () => {
            this.setState({'selected_ugyfelkartya': formData['loyalti_code'], 'shopping_cart': res.shopping_cart});
          });
      });
  }


  render_loyalty_form(){
    
    const {formData, formErrors, formSuccess, shopping_cart, selected_ugyfelkartya } = this.state;

    const ugyfelkartya = window.AppRef.current.get_ugyfelkartya();

    return <div className="loyalti_form">

        <div className={`field ${formErrors.loyalti_code !== '' ? "error" : ""}`}>
          {ugyfelkartya.cards && ugyfelkartya.cards.default.card ? 
            <select className="select" onChange={(e) => this.on_change_royalti_card(e)} value={selected_ugyfelkartya  ? selected_ugyfelkartya : ugyfelkartya.cards.default.card}>
                {
                  Object.keys(ugyfelkartya.cards.listbox).map((index,key)=>{
                    const item = ugyfelkartya.cards.listbox[index];
                    return <option key={key} value={index}>{item}</option>;
                  })
                }
              </select>
          : <input placeholder={i18n.t('shoppingCartLoyaltiPlaceholder')} type="text" value={formData.loyalti_code} onChange={(e) => this.handle_change(e, 'loyalti_code')} />
          }

            {(formErrors.loyalti_code.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.loyalti_code}}></div> : '' }
            {(formSuccess.loyalti_code.length) ? <div className="form_success" dangerouslySetInnerHTML={{__html: formSuccess.loyalti_code}}></div> : '' }
        </div>

        {
          !shopping_cart?.discounts?.ugyfelkartya?.ugyfelkartya_valid
          ?
          <>
            {window.AppRef.current.get_is_signed() ? <p dangerouslySetInnerHTML={{__html: i18n.t('shoppingCartLoyaltiText')}}></p> : ''}
            <button type="button" className="button" onClick={(e) => this.handle_loyalti_submit(e)}>{i18n.t('shoppingCartLoyaltiButtonText')}</button>
          </>
          :
          <>
            <div className='loyalti_card_info_cont'>
              {shopping_cart.discounts.ugyfelkartya.ugyfelkartya_gross ?
                <>
                  <div className="balnce_row">{i18n.t('shoppingCartLoyaltiBalance')} <span>{shopping_cart.discounts.ugyfelkartya.ugyfelkartya_gross}</span></div>
                  <div className='input_row'><label>{i18n.t('shoppingCartLoyaltiAppliedAmount')}</label> <input onChange={(event)=>{this.handle_change(event,'loyalti_use_gross')}} defaultValue={0} type='number' id="loyalti_used_balance"/><button onClick={(event)=>{this.handle_loyalti_submit()}}>{i18n.t('shoppingCartLoyaltiUseButton')}</button></div>
                  {shopping_cart.discounts.ugyfelkartya.ugyfelkartya_gross_errors ? <div className='loyalti_error_msg'>{shopping_cart.discounts.ugyfelkartya.ugyfelkartya_gross_errors}</div> : ''}
                  <div className='remainin_balace_row'>{i18n.t('shoppingCartLoyaltiRemainingBalance')} <span>{shopping_cart.discounts.ugyfelkartya.ugyfelkartya_remaining_gross}</span></div>
                </> 
              : ''}
              {shopping_cart.discounts.ugyfelkartya.coupons ?
                <div className='loyalti_coupons'>
                  <label>{i18n.t('shoppingCartLoyaltiCouponsLabelDescription')}</label>
                  <div className='select'>
                    <select onChange={(event)=>{this.handle_change(event,'loyalti_coupon_id',null,()=>{return this.handle_loyalti_submit()});}}>
                      <option value="-1">{i18n.t('shoppingCartLoyaltiCouponsSelectCoupon')}</option>
                      {
                        Object.keys(shopping_cart.discounts.ugyfelkartya.coupons).map((copon_index,key)=>{
                          const coupon_item = shopping_cart.discounts.ugyfelkartya.coupons[copon_index];
                          return <option key={coupon_item.id} value={coupon_item.id}>{coupon_item.name}</option>;
                        })
                      }
                    </select>
                  </div>
                  {(formErrors.coupon_code.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.coupon_code}}></div> : '' }
                </div>
                : ''
              }
            </div>
          </>
        }

        
    </div> 
  }

  render() {
    const {formData, formErrors, formSuccess, coupon_form_open, loyalti_form_open, show, hiding, shopping_cart,loading } = this.state;

    if (!show) return '';

    return <div className={`container floating_container page_checkout page_shopping_cart ${hiding ? 'out' : ''}`}>
          <div className="content">

          <PageHeader parent_ref={this} no_back title={i18n.t('shoppingCartTitle')} />

          {loading ? <div className='loader_cont'><div className='loader'><ReactSVG src='assets/images/dorko_loader.svg'></ReactSVG></div></div> : ''}
          
          {shopping_cart?.pc_sum ?
            <div className='container_inner'>
            {shopping_cart.products.map ? shopping_cart.products.map(product => <ProductCartItem key={product.id+'_'+product.pc+'_'+product.price_gross} product={product} on_change_product={product => this.on_change_product(product)} select_quantity />) : ''}

            <div className="loyalti">
              <div className="loyalti_title" onClick={(e) => this.toggle_loyalti_form_open(e)}>
                <label>{i18n.t('shoppingCartLoyaltiCode')}</label>
                <div className="toggler">{loyalti_form_open ? '-' : '+'}</div>
              </div>

              {loyalti_form_open ?
              this.render_loyalty_form() 
              : ''}
            </div> 

            {(!this.state.formData.loyalti_coupon_id || this.state.formData.loyalti_coupon_id=='-1') 
            ? 
            <div className="coupon">
              <div className="coupon_title" onClick={(e) => this.toggle_coupon_form_open(e)}>
                <label>{i18n.t('shoppingCartCouponCode')}</label>
                <div className="toggler">{coupon_form_open ? '-' : '+'}</div>
              </div>

              {coupon_form_open ? 
              <div className="coupon_form">
                  <div className={`field ${formErrors.coupon_code !== '' ? "error" : ""}`}>
                      <input type="text" value={formData.coupon_code} onChange={(e) => this.handle_change(e, 'coupon_code')} />
                      {(formErrors.coupon_code.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.coupon_code}}></div> : '' }
                      {(formSuccess.coupon_code.length) ? <div className="form_success" dangerouslySetInnerHTML={{__html: formSuccess.coupon_code}}></div> : '' }
                  </div>

                  <button type="button" className="button" onClick={(e) => this.handle_coupon_submit(e)}>{i18n.t('shoppingCartCouponButtonText')}</button>
              </div> : ''}
            </div> 
            : ''}
            

            <div className="checkout_summary">

              <div className="row">
                <label>{i18n.t('shoppingCartProductsTotal')}:</label>
                <p>{shopping_cart.sum_products_gross}</p>
              </div>
              {(shopping_cart?.discounts?.coupon_system?.coupon_gross) ?
                <div className='checkout_coupon_gross row'>
                  <label className='coupon_label'>{shopping_cart.discounts.coupon_system.coupon_number} <br/>{shopping_cart.discounts.coupon_system.coupon_label}</label>
                  <p className='coupon_gross_val'>-{shopping_cart.discounts.coupon_system.coupon_gross}</p> 
                </div> 
              : ''}
              {
                (shopping_cart?.discounts?.ugyfelkartya?.ugyfelkartya_valid && shopping_cart?.discounts?.ugyfelkartya?.ugyfelkartya_used_gross) ?
                <div className='checkout_coupon_gross row'>
                  <label className='coupon_label'>{i18n.t('shoppingCartLoyaltiSummingRow')} {shopping_cart.discounts.ugyfelkartya.ugyfelkartya_number}</label>
                  <p className='coupon_gross_val'>-{shopping_cart.discounts.ugyfelkartya.ugyfelkartya_used_gross}</p> 
                </div> 
                : ''
              }
              <div className="row total">
                <label>{i18n.t('shoppingCartTotal')}:</label>
                <p>{shopping_cart.sum_total_gross}</p>
              </div>

              <p className="checkout_vat_text" dangerouslySetInnerHTML={{__html: i18n.t('shoppingCartVatText')}}></p>
              
            </div>

            {window.AppRef.current.get_is_signed() ? 
              <button type="button" className="button" onClick={(e) => this.handle_submit(e)}>{i18n.t('shoppingCartSubmit')}</button>
            : <Link className="button" onClick={() => window.modals.ShoppingCartRef.current.hide()} data-type="in_app" to="/welcome">{i18n.t('shoppingCartSubmit')}</Link>}
            

            </div>
          :
            <div className='container_inner'><div className='emplty_list_message'>{i18n.t('shoppingCartEmptyMsg')}</div></div>
          }
          </div>
      </div>;
  }
}

export default ShoppingCart;